import { render, staticRenderFns } from "./legacy-home-change-device.vue?vue&type=template&id=e79514f2&scoped=true&"
import script from "./legacy-home-change-device.vue?vue&type=script&lang=js&"
export * from "./legacy-home-change-device.vue?vue&type=script&lang=js&"
import style0 from "./legacy-home-change-device.vue?vue&type=style&index=0&id=e79514f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79514f2",
  null
  
)

export default component.exports